<template>
    <HomeHeader/>
    <div class="bg-bg">
      <div class="user-wrapper flex mx-w-1200 w-984 m-auto py-8">
        <div class="user-wrapper__content flex-1">
          <slot/>
        </div>
      </div>
    </div>
    <FooterWrapper/>
</template>

<script>
import HomeHeader from '../components/home-header/HomeHeader.vue'
import FooterWrapper from '../components/home-footer/FooterWrapper.vue'
export default {
  components: {
    HomeHeader,
    FooterWrapper
  }
}
</script>

<style scoped>
.bg-bg{
  border-bottom: .5rem solid var(--primary-color);
}
</style>